<template>
    <div class="totals">
        <!-- 下注阶段 -->
        <div class="tips" v-if="gameStatus === 'BETTING'">
            <span class="text">{{ $t('niuniu.startBet') }}</span>
        </div>

        <!-- 停止下注 -->
        <div class="tips" v-else-if="gameStatus === 'STOP_BETTING'">
            <span class="text">{{ $t('niuniu.stopBet') }}</span>
        </div>
    </div>
</template>
<script setup lang="ts">
// 引入GameStatusType类型
type GameStatusType = 'PREPARING_NEXT_ROUND' | 'BETTING' | 'STOP_BETTING' | 'SHOW_RESULT'

const props = defineProps<{
    gameStatus?: GameStatusType
}>()

// 获取当前语言
const { locale } = useI18n();

</script>

<style lang="scss" scoped>
.totals {
    max-width: 500px;
    margin: 0 auto;
    width: 100%;
    height: 100vh;
    position: absolute;
    top: 0px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 8;
    display: flex;
    justify-content: center;
    align-items: center;
    /* 确保不影响页面布局 */
    pointer-events: none;
}

.tips {
    width: fit-content;
    margin: 0px auto;
    background-image: url(../img/indoor/bg_start.webp);
    background-repeat: no-repeat;
    background-size: 180%;
    background-position: center;
    padding: 27px 18px 11px;
    margin-top: var(--header-heigh);
    /* 恢复子元素的交互 */
    pointer-events: auto;
}

.text {
    font-size: 28px;
    color: white;
    font-weight: 800;
    line-height: 26px;
    letter-spacing: 1px;
    text-align: center;
}
</style>